module.exports = __webpack_public_path__ + "static/media/banner4.11928815.png";